import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnChanges, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import Editor from '@toast-ui/editor';

@Component({
  selector: 'app-markdown-editor',
  templateUrl: './markdown-editor.component.html',
  styleUrls: ['./markdown-editor.component.scss']
})
export class MarkdownEditorComponent {
constructor(
    
    public dialogRef: MatDialogRef<MarkdownEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any },
    private renderer: Renderer2,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    private apiService: ApiServiceModule,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    ) {}
    @ViewChild('editor') editorRef!: ElementRef;
    inProgress = false;
    editorInstance!: Editor;

    userInfos: { [x:string]: any } = this.data['user_infos'];
    rowInfos: { [x:string]: any } = this.data['row_infos'];
    platformInfos: { [x:string]: any }[] = this.data['platform_infos'];
    source: string = this.data['source'];
    widthListZone: number = 40;
    



    
    ngOnInit(){
    }
    ngAfterViewInit(): void {
      this.editorInstance = new Editor({
        el: this.editorRef.nativeElement,
        height: '80vh',
        initialEditType: 'markdown',
        previewStyle: 'vertical',
        usageStatistics: false,
      });
      this.editorInstance.setMarkdown(this.rowInfos['content_answer']);
    }

    saveContent(){
      
    }
    
    onClose(): void {
      this.dialogRef.close();
    }
    activatePage(page:string){
    
      this.cdRef.detectChanges();
    }
}
